module.exports = __webpack_public_path__ + "static/media/Durvesh.bf3c5904.jpg";